import { parseTime } from '@/utils/util'

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 80,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'org',
    align: 'left',
    width: 260,
    // scopedSlots: { customRender: 'org' }
  },
  {
    title: '采访期数',
    dataIndex: 'cover_no',
    width: 90,
    align: 'left'
  },
  {
    title: '采访标题',
    dataIndex: 'title',
    width: 260,
    align: 'left'
  },
  {
    title: '被采访人',
    dataIndex: 'name',
    width: 120,
    align: 'left'
  },
  {
    title: '采访人',
    dataIndex: 'nickname',
    width: 120,
    align: 'left'
  },
  {
    title: '发布人',
    dataIndex: 'user_id',
    align: 'left',
    width: 150,
    scopedSlots: { customRender: 'user_id' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '发布日期',
    dataIndex: 'created_at',
    align: 'left',
    width: 180,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    align: 'center',
    width: 150,
    // fixed: 'right',
    dataIndex: 'operator',
    scopedSlots: { customRender: 'operator' }
  }
]

export const searchForm = {
  state: undefined,
  user: '',
  start_date: '',
  end_date: '',
  password: ''
}
